import { Subject } from 'rxjs/Subject';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nbp-confirm',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Nota Premiada Bahia - Atenção!</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <h5>{{mensagem}}</h5>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="onUserConfirm(true)">OK</button>
      <button type="button" class="btn btn-danger" (click)="onUserConfirm(false)">Cancelar</button>
    </div>`
})
export class NbpConfirmComponent {

  @Input() mensagem;
  public userConfirmChange: Subject<boolean> = new Subject<boolean>();

  constructor(public activeModal: NgbActiveModal) {}

  onUserConfirm(userSelection: boolean) {
    this.userConfirmChange.next(userSelection);
    this.activeModal.close('Seleção Usuário');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/nbp-confirm.component.ts